import {
  Button,
  Divider,
  Group,
  SimpleGrid,
  Stack,
  Title,
} from "@mantine/core";
import { useHover } from "@mantine/hooks";
import { IconChevronLeft } from "@tabler/icons-react";
import { Fragment } from "react";
import { ProductCategory, ProductChoice } from "./product";
import { ProductCard } from "./SingleProductCard";
import { ProductTypeV2 } from "/@/generated/graphql";

type CategoryPanelProps = {
  category: ProductCategory;
  selectedType: ProductTypeV2 | null;
  onBack?: () => void;
  onSelect: (choice: ProductChoice) => void;
};

export const CategoryPanel = (props: CategoryPanelProps) => {
  const { ref } = useHover<HTMLButtonElement>();

  const uniqueBySubCategory = (categories: string[]) => {
    const seen = new Set<string>();
    return categories.filter(c => {
      if (seen.has(c)) return false;
      seen.add(c);
      return true;
    });
  };

  return (
    <Stack gap="s4">
      <Group gap="s3">
        {props.onBack && (
          <Button
            ref={ref}
            variant="default"
            leftSection={<IconChevronLeft size={15} />}
            onClick={props.onBack}
          >
            Toutes les familles
          </Button>
        )}
        <Title variant="display" size={15}>
          {props.category.label}
        </Title>
      </Group>
      {!props.category.hasSubCategories ? (
        <SimpleGrid cols={{ base: 2, md: 4 }} style={{ gridAutoRows: "1fr" }}>
          {props.category.choices.map(choice => (
            <ProductCard
              key={choice.type}
              {...choice}
              isSelected={props.selectedType === choice.type}
              onClick={() => props.onSelect(choice)}
            />
          ))}
        </SimpleGrid>
      ) : (
        uniqueBySubCategory(
          props.category.choices.map(c => c.subcategory as string)
        ).map(subcategoryLabel => (
          <Fragment key={subcategoryLabel}>
            <Divider
              my="xs"
              fw={500}
              label={subcategoryLabel.toUpperCase()}
              labelPosition="left"
            />

            <SimpleGrid
              cols={{ base: 2, md: 4 }}
              style={{ gridAutoRows: "1fr" }}
            >
              {props.category.choices
                .filter(c => c.subcategory === subcategoryLabel)
                .map(choice => (
                  <ProductCard
                    key={choice.type}
                    {...choice}
                    isSelected={props.selectedType === choice.type}
                    onClick={() => props.onSelect(choice)}
                  />
                ))}
            </SimpleGrid>
          </Fragment>
        ))
      )}
    </Stack>
  );
};
